import { CubeOutlineIcon } from './CubeOutlineIcon';

/**
 * author: Austin Andrews
 * id 11B7F7B5-8813-48DE-9469-B1159355DDC3
 * name cube-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cube-outline.svg
 * tags
 * - Shape 
 * - Food / Drink 
 */
export const SugarIcon = CubeOutlineIcon;
export default SugarIcon